import { useCallback, useState } from "react";
import { SupportSheet } from "../components/SupportSheet";

/**
 * Wires the support sheet to the screen that owns the "need help" affordance:
 * pass `openSupport` to the Navbar icon and render `supportSheet` next to the
 * layout, so the sheet slides up over the screen the user is already on.
 */
export const useSupportSheet = () => {
  const [visible, setVisible] = useState(false);
  const openSupport = useCallback(() => setVisible(true), []);
  const closeSupport = useCallback(() => setVisible(false), []);

  return {
    openSupport,
    closeSupport,
    supportSheet: <SupportSheet visible={visible} onClose={closeSupport} />,
  };
};
